import { createSelector } from 'reselect';

import { AppState } from '../rootReducer';

const getLoading = (state: AppState) => state.district.loading;
const getDistrictList = (state: AppState) => state.district.districtList;
const getDistrictCount = (state: AppState) => state.district.total;
const getError = (state: AppState) => state.district.error;

export const districtLoadingSelector = createSelector(getLoading, (loading) => loading);

export const getDistrictListSelector = createSelector(getDistrictList, (districtList) => districtList);

export const districtCountSelector = createSelector(getDistrictCount, (total) => total);

export const districtErrorSelector = createSelector(getError, (error) => error);
